export enum AssetType {
  DEVICE = 'device',
  RUUVI_TAG = 'ruuvi_tag'
}
